var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDigitalKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    className: "digital-key_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19v5l-2.732 2.732M24 19v5l2.734 2.734"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 28.5,
    r: 2.5,
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 2.5,
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 28.5,
    r: 2.5,
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26V16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.317 5a7 7 0 100 6H21l2 2 2-2h4l1-6z",
    "data-cap": "butt",
    strokeLinecap: "butt"
  }))));
}

export default SvgDigitalKey;